import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const NaturalResourses = (props) => {
  const handleBeneficiaries = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          natural_resources: Number(value),
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>8.6</span>
          <span className="star">*</span>
        </div>
)}
      titleUA="Природні ресурси"
      titleEN="Natural resourses"
      children={(
        <div className="flex-group">
          <input
            placeholder="0"
            id="natural_resources"
            name="natural_resources"
            className="number"
            value={props.formData.info.landuse_and_beneficiaries.natural_resources}
            autoComplete="off"
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              const total = props.checkPercent('natural_resources') + newValue;
              if (total <= 100) {
                handleBeneficiaries(newValue);
              } else {
                e.preventDefault();
              }
            }}
          />
          <span>%</span>
        </div>
)}
    />
  );
};
